"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._SSEKMS = {
    type: "structure",
    required: ["KeyId"],
    members: {
        KeyId: {
            shape: {
                type: "string",
                sensitive: true
            }
        }
    }
};
//# sourceMappingURL=_SSEKMS.js.map